import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {UserDetail} from "@model";
import {AdministratorsService} from "@services";
import {inject} from "@angular/core";

export const AdministratorsListReslover: ResolveFn<Observable<UserDetail[]>> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  administratorsService: AdministratorsService = inject(AdministratorsService)
  ): Observable<UserDetail[]> => administratorsService.findAdministrators();
